import lj from './lumberjack';
import { debounce, isMobile } from './modules/util';

lj.setupLJ();

const DEFAULT_CAMPAIGN_ID = 'nitro-null-website';
const DEFAULT_FORM_VERSION = 'without_fields';

const query = new URLSearchParams(window.location.search);
const mid = query.get('mid') || '';
const campaignId = query.get('campaignID') || DEFAULT_CAMPAIGN_ID;
const formVersion =
  query.get('form_version') && query.get('form_version') === 'withformfields'
    ? 'with_fields'
    : DEFAULT_FORM_VERSION;

if (formVersion !== DEFAULT_FORM_VERSION) {
  $('#xca-form-new-version').removeClass('hide');
} else {
  $('#xca-form').removeClass('hide');
}

let email = query.get('email');
let phone = query.get('phone');
let customerName = null;
let inputEventFired = false;
let currentRole = null;
let noOfEmployees = null;
let hasCorporateCreditCard = null;

const setLoading = (show = false) => {
  const className =
    formVersion === DEFAULT_FORM_VERSION ? 'xca-form' : 'xca-form-new-version';
  if (show) {
    $('.xca-form-loader').removeClass('hide');
    $(`#${className}`).addClass('hide');
  } else {
    $('.xca-form-loader').addClass('hide');
    $(`#${className}`).removeClass('hide');
  }
};

const setError = (show = false) => {
  const className =
    formVersion === DEFAULT_FORM_VERSION
      ? '.errorMessage'
      : '#new-version-errorMessage';

  if (show) {
    $(className).removeClass('hide');
  } else {
    $(className).addClass('hide');
  }
};

const setSubmitting = disabled => {
  const className =
    formVersion === DEFAULT_FORM_VERSION
      ? '#submit-button'
      : '.mobile-submit-button > #new-version-submit-button, #new-version-submit-button';
  const submitButton = $(`${className}`);
  if (disabled) {
    submitButton.html('Submitting...');
  } else {
    submitButton.html('Get Offer Now');
  }
  submitButton.prop('disabled', disabled);
};

const setSubmitted = () => {
  $('#xca-form').attr('style', 'display: none !important;');
  $('#xca-form-new-version').attr('style', 'display: none !important;');
  $('#xca-form-submitted-successfully').removeClass('hide');
  lj.pushEvents({
    event_name: 'websiteleads.success_page',
    event_type: 'viewed',
    properties: {
      mid,
      campaignId,
      formVersion
    }
  });
};

const sendDataToHubspot = () => {
  const formId =
    formVersion === DEFAULT_FORM_VERSION
      ? '86f8d5ce-97cb-4484-a748-607fe1ae464f'
      : '065b5a7a-744d-4b44-89df-6f1358766791';

  const commonFields = [
    {
      name: 'phone',
      value: phone
    },
    {
      name: 'email',
      value: email
    },
    {
      name: 'campaignid',
      value: campaignId
    }
  ];
  let formValues = [];

  if (formVersion === DEFAULT_FORM_VERSION) {
    formValues = [
      ...commonFields,
      {
        name: 'merchant_id__c',
        value: mid
      }
    ];
  } else {
    formValues = [
      ...commonFields,
      {
        name: 'full_name',
        value: customerName
      },
      {
        name: 'what_is_your_current_role_',
        value: currentRole
      },
      {
        name: 'how_many_employees_do_you_have_in_your_company_',
        value: noOfEmployees
      },
      {
        name: 'do_you_currently_have_a_corporate_credit_card_',
        value: hasCorporateCreditCard
      }
    ];
  }

  const payload = {
    fields: [...formValues],
    context: {
      pageUri: window.location.href,
      pageName: document.title
    }
  };

  return fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/5558946/${formId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  );
};

const sendDataToSalesForce = () => {
  const payload = {
    event_type: 'CURRENT_ACCOUNT_INTEREST',
    event_properties: {
      interested_in_current_account: 1,
      product_name: 'Current_Account',
      source: 'Project Nitro',
      Campaign_ID: campaignId,
      contact_email: email,
      contact_name: customerName,
      contact_mobile: phone,
      form_version: formVersion,
      what_is_your_current_role: currentRole,
      how_many_employees_do_you_have_in_your_company: noOfEmployees,
      do_you_currently_have_a_corporate_credit_card: hasCorporateCreditCard
    }
  };

  return fetch(
    `https://api.razorpay.com/v1/merchant/${mid}/salesforce_event_website`,
    // `https://beta-api.stage.razorpay.in/v1/merchant/${mid}/salesforce_event_website`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  );
};

const submitForm = (auto = false) => {
  lj.pushEvents({
    event_name: 'websiteleads.form_submit',
    event_type: 'initiated',
    properties: {
      mid,
      campaignId,
      auto,
      manual: !auto,
      formVersion
    }
  });

  setSubmitting(true);

  sendDataToHubspot()
    .then(res => {
      if (!res.ok) {
        throw new Error('Something went wrong');
      } else if (mid) {
        return sendDataToSalesForce();
      }

      return true;
    })
    .then(res => {
      if (typeof res === 'object' && !res.ok) {
        throw new Error('Something went wrong');
      } else {
        window.rzpAnalytics({
          eventLabel: 'signup_complete',
          eventAction: 'Signup Complete',
          eventCategory: 'XCA Request',
          fbevent: 'signup_complete',
          linkedinconversionid: '4257268'
        });

        setSubmitted(true);
        setLoading(false);
      }
    })
    .catch(err => {
      console.log(err);
      setError(true);
      setLoading(false);
      setSubmitting(false);
    });
};

if (email && phone && formVersion === DEFAULT_FORM_VERSION) {
  setLoading(true);
  submitForm(true);
}

function fireInputEvent() {
  lj.pushEvents({
    event_name: 'websiteleads.click_form_input',
    event_type: 'initiated',
    properties: {
      mid,
      campaignId,
      formVersion
    }
  });

  inputEventFired = true;
}

function validateEmail(e) {
  let regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  if (!regExp.test($(e).val())) {
    return false;
  }
  return true;
}

function validateContactNumber(e) {
  let regExp = /^(\d{10,12})$/;
  if (!regExp.test($(e).val())) {
    return false;
  }
  return true;
}

function updateOnInputChange() {
  if (formVersion === DEFAULT_FORM_VERSION) {
    email = $('#email').val();
    phone = $('#phone').val();
  } else {
    customerName = $('#new-version-name').val();
    email = $('#new-version-email').val();
    phone = $('#new-version-phone').val();
    currentRole = $('input[name=current-role]:checked').val();
    noOfEmployees = $('input[name=no-of-employees]:checked').val();
    hasCorporateCreditCard = $(
      'input[name=has-corporate-credit-card]:checked'
    ).val();
  }
}

$('#submit-button,#new-version-submit-button').click(() => {
  submitForm();
});

function toggleSubmitButtonDisableState() {
  const isValidEmail =
    formVersion === DEFAULT_FORM_VERSION
      ? validateEmail($('#email'))
      : validateEmail($('#new-version-email'));
  const isValidPhone =
    formVersion === DEFAULT_FORM_VERSION
      ? validateContactNumber($('#phone'))
      : validateContactNumber($('#new-version-phone'));

  if (formVersion !== DEFAULT_FORM_VERSION) {
    if (isMobile()) {
      if (!isValidEmail || !isValidPhone || !customerName) {
        $('#continue-button').prop('disabled', true);
      } else {
        $('#continue-button').prop('disabled', false);
      }
    }

    if (
      !isValidEmail ||
      !isValidPhone ||
      !customerName ||
      !currentRole ||
      !noOfEmployees ||
      !hasCorporateCreditCard
    ) {
      $(
        '.mobile-submit-button > #new-version-submit-button, #new-version-submit-button'
      ).prop('disabled', true);
    } else {
      $(
        '.mobile-submit-button > #new-version-submit-button, #new-version-submit-button'
      ).prop('disabled', false);
    }
  } else {
    if (!isValidEmail || !isValidPhone) {
      $('#submit-button').prop('disabled', true);
    } else {
      $('#submit-button').prop('disabled', false);
    }
  }
}

function runValidations() {
  updateOnInputChange();
  toggleSubmitButtonDisableState();

  if (!inputEventFired) {
    fireInputEvent();
  }
  const emailError = $('#emailError');
  if (!emailError.hasClass('hide')) emailError.addClass('hide');

  const phoneError = $('#phoneError');
  if (!phoneError.hasClass('hide')) phoneError.addClass('hide');
}

$('input,textarea').on(
  'keyup',
  debounce(() => {
    runValidations();
  }, 100)
);

$('input[type=checkbox],input[type=radio]').on(
  'change',
  debounce(() => {
    runValidations();
  }, 100)
);

$('#view-docs-cta').on('click', () => {
  lj.pushEvents({
    event_name: 'websiteleads.click_view_docs',
    event_type: 'initiated',
    properties: {
      mid,
      campaignId,
      formVersion
    }
  });
});

$('#continue-button').on('click', () => {
  $('.right-form').removeClass('nomob');
  $('.steps-row p').text('Step 2/2');
  $('#xca-form-new-version .formContainer, .mobile-continue-button').addClass(
    'hide'
  );
  $('.mobile-submit-button').removeClass('hide');
  const rf = document.getElementById('xca-form-new-version');
  rf.scrollIntoView(true);
});

window.onload = function() {
  lj.pushEvents({
    event_name: 'websiteleads.display_form',
    event_type: 'success',
    properties: {
      mid,
      campaignId,
      formVersion
    }
  });
};
